export default __webpack_public_path__ + "static/media/FlyingFrog8.18c6499a.png";